(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const selectors = ['.card-variant-swatches', '.card__heading', '.centric-activity-feel', '.color-name'];
  let pending = false;
  const original = new WeakMap();
  function align() {
    pending = false;
    const cards = [...document.querySelectorAll('.product-card-wrapper')].filter(card => card.querySelector('.centric-activity-feel'));
    cards.forEach(card => selectors.forEach(selector => {
      const element = card.querySelector('.card__information ' + selector);
      if (element) {
        if (!original.has(element)) original.set(element, { minHeight: element.style.minHeight, marginTop: element.style.marginTop });
        const saved = original.get(element);
        element.style.minHeight = saved.minHeight;
        element.style.marginTop = saved.marginTop;
      }
    }));
    if (!mobile.matches) return;
    const groups = new Map();
    cards.forEach(card => {
      if (!card.getClientRects().length || card.getBoundingClientRect().width === 0) return;
      const container = card.parentElement.parentElement;
      if (!groups.has(container)) groups.set(container, []);
      groups.get(container).push(card);
    });
    groups.forEach(group => {
      const rows = [];
      group.forEach(card => {
        const top = card.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 3);
        if (!row) { row = { top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      rows.forEach(row => selectors.forEach(selector => {
        const elements = row.cards.map(card => card.querySelector('.card__information ' + selector)).filter(Boolean);
        if (elements.length < 2) return;
        const offsets = elements.map(element => element.getBoundingClientRect().top - element.closest('.product-card-wrapper').getBoundingClientRect().top);
        const offset = Math.max(...offsets);
        elements.forEach((element, index) => {
          const difference = offset - offsets[index];
          if (difference > 0.5) element.style.marginTop = (parseFloat(getComputedStyle(element).marginTop) + difference) + 'px';
        });
        const height = Math.max(...elements.map(element => element.getBoundingClientRect().height));
        elements.forEach(element => { element.style.minHeight = height + 'px'; });
      }));
    });
  }
  function schedule() {
    if (!pending) { pending = true; requestAnimationFrame(align); }
  }
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('change', schedule);
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();